import { Addon } from '../../../types/cms_shared_types';
import { Product } from '../../../types/webshop';

interface CartItemChanges<T> {
  addedItems: T[];
  removedItems: T[];
  editedItems: T[];
}

export const getCartItemChanges = <T extends Addon | Product>(
  updatedItems: T[],
  prevItems: T[],
): CartItemChanges<T> => {
  const addedItems = updatedItems?.filter((item) => isAddedItem(item, prevItems));
  const removedItems = prevItems?.filter((prev) => isRemovedItem(prev, updatedItems));
  const editedItems = updatedItems?.filter((item) => isEditedItem(item, prevItems));

  return { addedItems, removedItems, editedItems };
};

const isAddedItem = <T extends Addon | Product>(item: T, prevItems: T[]): boolean => {
  return !prevItems.map((prev) => prev.code).includes(item.code);
};

const isRemovedItem = <T extends Addon | Product>(prev: T, updatedItems: T[]): boolean => {
  return !updatedItems.map((item) => item.code).includes(prev.code);
};

const isEditedItem = <T extends Addon | Product>(item: T, prevItems: T[]): boolean => {
  const prevItem = prevItems.find((prev) => prev.code === item.code);

  if (!prevItem) {
    return false;
  }

  return JSON.stringify(prevItem) !== JSON.stringify(item);
};
